export default __webpack_public_path__ + "static/media/opportunities.d2fda6d7.svg";